import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_w6b6bvkhz4: FaireBrandEntity = {
  token: "b_w6b6bvkhz4",
  type: "brand",
  name: "Lexi Home",
  avatarUrl:
    "https://cdn.faire.com/fastly/91b820ae8027354953733b6ab968d7c25780d1a41e8b43eacc2b5d2c66bcc8cc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c2b50b421603ba0547792c8a55e80710f3e81ddb6adade7d8b333820f2af93a3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/91b820ae8027354953733b6ab968d7c25780d1a41e8b43eacc2b5d2c66bcc8cc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c2b50b421603ba0547792c8a55e80710f3e81ddb6adade7d8b333820f2af93a3.jpeg",
  location: "Torrance, CA, USA",
  minimumOrderDollars: 1000,
  rating: 4.6,
  reviewCount: 33,
  isTopShop: true,
  isInsider: true,
  description:
    "Lexi Home has maintained a commitment to producing functional and quality home appliances and products for every home. Having been in the business for 30 years, Lexi Home has focused on innovation and simplicity to fit seamlessly into customers’ needs.\n\nOur strengths stem from our ability to constantly customize our goods without compromising on quality and reliability all while maintaining an affordable price point. We carry a versatile product line which has shown consistent growth and maintained flexibility so we can easily adapt to the changing times.\n\nWe ship all of our items from our 80000 square foot facility in Torrance, CA and ship across the USA excluding Alaska, Hawaii, Puerto Rico, Guam, and the US Virgin Islands.",
  meta: {
    source: "api",
    importedAt: "2026-08-12T18:06:35.227Z",
    importedBy: "entity-db-cli",
  },
};
